// ChargeList.jsx — 직원별 1:1급여 목록 (2026-10-06 UX, 종전 MonthlyCalculationTable 대체)
//   확인 필요 → 점검 → 정상 순서, [전체][확인 필요][점검] 거르기. 카드엔 이름·담당 마케터·1:1급여·상태 하나만.
import React from 'react';
import { fmtMoney } from './monthlyCalculationUtils';
import { rowPendingCount, rowState, sortRows, stateCounts, STATE_LABEL } from './chargeModel';
import { C } from './charge.styles';

const TONE_BY_STATE = { pending: 'warn', check: 'danger', ok: 'ok' };

export function filterRows(rows, filter) {
  const sorted = sortRows(rows);
  if (filter === 'pending') return sorted.filter((row) => rowState(row) === 'pending');
  if (filter === 'check') return sorted.filter((row) => rowState(row) === 'check');
  return sorted;
}

export function ChargeList({ rows = [], filter, onFilter, selectedId, onSelect, loading }) {
  const counts = stateCounts(rows);
  const list = filterRows(rows, filter);
  return (
    <div style={C.listWrap}>
      <div style={C.listHead}>
        <span style={C.listTitle}>직원별 1:1급여 {rows.length}명</span>
      </div>
      <div style={C.filters}>
        <button type="button" style={C.filterChip(filter === 'all')} onClick={() => onFilter('all')}>전체 {rows.length}</button>
        <button type="button" style={C.filterChip(filter === 'pending')} onClick={() => onFilter('pending')}>확인 필요 {counts.pending}</button>
        <button type="button" style={C.filterChip(filter === 'check')} onClick={() => onFilter('check')}>점검 {counts.check}</button>
      </div>
      {loading && !rows.length && <div style={C.empty}>불러오는 중입니다.</div>}
      {!loading && !rows.length && <div style={C.empty}>이 달에 겹치는 1:1 배정이 없습니다.</div>}
      {rows.length > 0 && !list.length && <div style={C.empty}>이 조건에 맞는 직원이 없습니다.</div>}
      {list.map((row) => {
        const state = rowState(row);
        const pending = rowPendingCount(row);
        const label = state === 'pending' ? `확인 필요 ${pending}` : STATE_LABEL[state];
        return (
          <button
            key={row.assignmentId}
            type="button"
            style={C.personCard(row.assignmentId === selectedId)}
            onClick={() => onSelect(row.assignmentId)}
          >
            <span style={C.personTop}>
              <span style={C.personName}>{row.consultantName || '-'}</span>
              <span style={C.personAmount}>{fmtMoney(row.chargeAmount)}</span>
            </span>
            <span style={C.personMeta}>담당 {row.marketerName || '-'} · {row.activeDays}/{row.monthDays}일 근무</span>
            <span style={C.badge(TONE_BY_STATE[state])}>{label}</span>
          </button>
        );
      })}
    </div>
  );
}
